import React from 'react'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'
import type { EditableComponentPropsType } from '../../../utils/prop-types'
import type { CustomProductCardProps } from './types'
import CustomProductCardEditConfig from './CustomProductCardEditConfig'
import Container from '../../templates/Container/Container'

const CustomProductCard: React.FC<
  EditableComponentPropsType<CustomProductCardProps>
> = withComponentRefresh<CustomProductCardProps>((props) => {
  const { id, gcodes, images, ...rest } = props.model || {}
  const editableProps = useExtractEditableProps(props, rest)

  return (
    <EditableComponent {...editableProps}>
      {AuthoringUtils.isInEditor() &&
      CustomProductCardEditConfig.isEmpty(props.model) ? (
        CustomProductCardEditConfig.emptyLabel
      ) : (
        <>
          <pre>{JSON.stringify(props.model, null, 2)}</pre>
          <Container {...editableProps} />
        </>
      )}
    </EditableComponent>
  )
})

const CustomProductCardWithErrorBoundary = withErrorBoundary(
  CustomProductCard,
  {
    componentName: 'CustomProductCard',
    fallback: <ErrorFallback componentName="CustomProductCard" />
  }
)

export default CustomProductCardWithErrorBoundary
